import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";
import { fetchData } from "../helper/api.interceptor";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import {
  FaBoxOpen,
  FaCreditCard,
  FaFileInvoice,
  FaFileAlt,
  FaDownload,
  FaEye
} from "react-icons/fa";

import "./customer-order-details.css";

const Customerorderdetails = () => {
  const { phone } = useParams();
  const [quotationData, setQuotationData] = useState(null);
  const [orderSummaryStatus, setOrderSummaryStatus] = useState("");
  const [processingDoc, setProcessingDoc] = useState(null);
  const [transactionDetails, setTransactionDetails] = useState([]);

  useEffect(() => {
    const fetchQuotationDetails = async () => {
      try {
        const phone_number = decodeURIComponent(phone);
        const quotationRes = await fetchData.post("/get-final-quotation", { phone_number });

        if (quotationRes.status_code === 200) {
          setQuotationData(quotationRes.result.quotation);
          if (quotationRes.result.quotation.payment?.payment_order_id) {
            const txnRes = await fetchData.get(
              `/get-payment-details?orderId=${quotationRes.result.quotation.payment.payment_order_id}`
            );
            if (txnRes.status_code === 200) {
              setTransactionDetails(txnRes.result || []);

            }
          }
          setOrderSummaryStatus(quotationRes.result.quotation.order_summary?.status || "");
        } else {
          Swal.fire("Error", "Failed to load quotation data", "error");
        }
      } catch (error) {
        console.error(error);
        Swal.fire("Error", "Something went wrong", "error");
      }
    };


    if (phone) fetchQuotationDetails();

  }, [phone]);
  const handleStatusUpdate = async () => {
    if (!orderSummaryStatus) return;

    const formData = new FormData();
    formData.append("phone_number", quotationData.phone_number);
    formData.append("status", orderSummaryStatus);

    if (orderSummaryStatus === "Customer Sign/Invoice" && processingDoc) {
      formData.append("document", processingDoc);
    }

    try {
      const res = await fetchData.postWithFormData("/order/status", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (res.status_code === 200) {
        Swal.fire("Success", "Status updated successfully", "success");

        // refresh the order summary status
        setQuotationData((prev) => ({
          ...prev,
          order_summary: {
            ...prev.order_summary,
            status: orderSummaryStatus,
          },
        }));
      } else {
        Swal.fire("Error", res.message || "Failed to update status", "error");
      }
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Something went wrong", "error");
    }
  };
  const updateDocumentStatus = async (type, status) => {
    try {
      const response = await fetchData.post("/update-doc-status", {
        phone_number: quotationData.phone_number,
        type,
        status,
      });

      if (response.status_code === 200) {
        Swal.fire("Success", `Document ${status} successfully`, "success");
        // Refresh the data to reflect the updated status
        setQuotationData(prev => {
          const updatedDocs = { ...prev.documents };
          updatedDocs[type].status = status;
          return { ...prev, documents: updatedDocs };
        });
      } else {
        Swal.fire("Error", response.message || "Failed to update status", "error");
      }
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Something went wrong", "error");
    }
  };

  const customerData = quotationData;
  const orderSummary = quotationData?.order_summary;
  const documentData = quotationData?.documents;

  return (
    <div className="customer-order-details">
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24">
        <h6 className="fw-semibold mb-0">Customers Order Details</h6>
        <ul className="d-flex align-items-center gap-2">
          <li className="fw-medium">
            <Link to="/customers" className="d-flex align-items-center gap-1 hover-text-primary">
              <Icon icon="solar:home-smile-angle-outline" className="icon text-lg" />
              Customers
            </Link>
          </li>
          <li> - </li>
          <li className="fw-medium">Order Summary</li>
        </ul>
      </div>
      <div className="row gy-2">

        {/* Personal Details */}
        <div className="col-12">
          <div className="customer-detail-box p-20 shadow-sm">
            <h5 className="mb-3 d-flex align-items-center gap-2">
              <Icon icon="iconamoon:profile-circle-light" /> |
              Personal Details
            </h5>
            {customerData ? (
              <div className="row">
                {[
                  { label: "Name", value: customerData.personal_details?.user_name },
                  { label: "Phone", value: customerData.phone_number },
                  { label: "Email", value: customerData.personal_details?.email },
                  { label: "State", value: customerData?.address?.state },
                  { label: "District", value: customerData?.address?.district },
                  { label: "City/Village", value: customerData?.address?.city_or_village },
                  { label: "Pincode", value: customerData?.address?.pincode },
                ].map((item, idx) => (
                  <div className="col-md-3" key={idx}>
                    <h6 className="mb-1">{item.label}:</h6>
                    <p className="mb-3">{item.value || "-"}</p>
                  </div>
                ))}
              </div>
            ) : (
              <p>Loading personal details...</p>
            )}
          </div>
        </div>

        {/* Order Summary */}
        <div className="col-lg-6">
          <div className="customer-detail-box p-20 shadow-sm h-100 position-relative">

            {/* Top right download section */}
            {orderSummary?.customersigndoc && (
              <div className="position-absolute top-0 end-0 text-end">
                <div className="d-flex align-items-center gap-2 custom_padding">
                  <label className="fw-semibold mb-0">Customer Sign Document:</label>
                  <FaDownload
                    size={18}
                    style={{ cursor: "pointer" }}
                    title="Download"
                    className="text-primary"
                    onClick={() => {
                      const basePath = process.env.REACT_APP_UPLOAD_PATH;
                      const filePath = orderSummary.customersigndoc;
                      const fileUrl = `${basePath}${filePath}`;

                      fetch(fileUrl)
                        .then((response) => {
                          if (!response.ok) throw new Error("Network response was not ok.");
                          return response.blob();
                        })
                        .then((blob) => {
                          const url = window.URL.createObjectURL(blob);
                          const a = document.createElement("a");
                          a.href = url;
                          a.download = filePath.split("/").pop();
                          document.body.appendChild(a);
                          a.click();
                          a.remove();
                          window.URL.revokeObjectURL(url);
                        })
                        .catch((error) => {
                          console.error("Download error:", error);
                          alert("File could not be downloaded.");
                        });
                    }}
                  />
                </div>
              </div>
            )}



            {/* Title */}
            <h5 className="mb-4 d-flex align-items-center gap-2 fs-5">
              <FaBoxOpen className="text-success fs-4" /> | Order Summary
            </h5>

            {orderSummary ? (
              <div className="order-summary-content">
                <div className="mb-3">
                  <span className="text-muted fw-semibold">Order ID:</span>
                  <span className="d-block fs-6 fw-bold">{orderSummary.order_id || "-"}</span>
                </div>

                <div className="mb-3">
                  <span className="text-muted fw-semibold">Reading Date:</span>
                  <span className="d-block fs-6 fw-bold">
                    {new Date(orderSummary.reading_date).toLocaleDateString()}
                  </span>
                </div>

                <div className="mb-3">
                  <span className="text-muted fw-semibold">Panel:</span>
                  <span className="d-block fs-6 fw-bold text-dark">
                    {orderSummary.panel_brand} - ₹{orderSummary.panel_price.toLocaleString("en-IN")}
                  </span>
                </div>

                <div className="mb-3">
                  <span className="text-muted fw-semibold">Inverter:</span>
                  <span className="d-block fs-6 fw-bold text-dark">
                    {orderSummary.inverter_brand} - ₹{orderSummary.inverter_price.toLocaleString("en-IN")}
                  </span>
                </div>

                {/* Status Section */}
                <div className="mb-3">
                  <span className="text-muted fw-semibold">Status:</span>
                  <span className="d-block fs-6 fw-bold text-primary mb-2">
                    {/* {orderSummary.status} */}
                  </span>

                  {/* Status Update UI */}
                  <div className="d-flex flex-column gap-2">

                    {/* Show uploaded document link below if needed */}

                    {/* Dropdown to select status */}
                    <select
                      className="form-select"
                      value={orderSummaryStatus}
                      onChange={(e) => setOrderSummaryStatus(e.target.value)}
                    >
                      {["Pending", "Customer Sign/Invoice", "Structure work", "Panel Fitting", "Electric work", "Invertor Fitting", "Complete Install meter", "Bill Generate Signature"].map((status) => (
                        <option key={status} value={status}>
                          {status}
                        </option>
                      ))}
                    </select>

                    {/* Show upload only if status is Processing */}
                    {orderSummaryStatus === "Customer Sign/Invoice" && (
                      <div>
                        <label htmlFor="docUpload" className="form-label">Upload Customer Sign/Invoice Document</label>
                        <input
                          type="file"
                          className="form-control"
                          id="docUpload"
                          onChange={(e) => setProcessingDoc(e.target.files[0])}
                        />
                      </div>
                    )}

                    <button
                      className="btn btn-sm btn-primary w-fit"
                      style={{
                        width: "150px",
                        backgroundColor: "#e4d838ff",
                        color: "black",
                        fontSize: "16px",
                        fontWeight: "500"
                      }}
                      onClick={handleStatusUpdate}
                    >
                      Update Status
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <p>Loading order summary...</p>
            )}
          </div>
        </div>

        {/* Payment */}


        {/* Payment Summary */}
        <div className="col-lg-6">
          <div className="customer-detail-box p-20 shadow-sm h-100">
            <h5 className="mb-3 d-flex align-items-center gap-2">
              <FaCreditCard className="text-danger fs-4" /> | Payment Summary
            </h5>

            {quotationData?.payment?.mode && (
              <div className="col-12 mb-3">
                <div className="bg-light border rounded p-3 d-inline-block">
                  <h6 className="mb-0 fw-semibold">
                    Payment Mode:{" "}
                    <span className="text-primary">
                      {quotationData.payment.mode === "full" ? "Full Payment" : "Loan Payment"}
                    </span>
                  </h6>
                </div>
              </div>
            )}

            {quotationData?.payment ? (
              <ul className="quotation-payment list-unstyled">
                {/* Basic Costing */}
                <li className="d-flex justify-content-between align-items-center border-bottom pb-1">
                  <span className="text-muted">Panel Price</span>
                  <span className="fw-bold text-dark">
                    ₹{quotationData.order_summary?.panel_price?.toLocaleString("en-IN") || "0"}
                  </span>
                </li>
                <li className="d-flex justify-content-between align-items-center border-bottom pb-1">
                  <span className="text-muted">Inverter Price</span>
                  <span className="fw-bold text-dark">
                    ₹{quotationData.order_summary?.inverter_price?.toLocaleString("en-IN") || "0"}
                  </span>
                </li>
                <li className="d-flex justify-content-between align-items-center border-bottom pb-1">
                  <span className="text-muted">Other System Cost</span>
                  <span className="fw-bold text-dark">
                    ₹{(
                      (quotationData.payment?.total_cost || 0) -
                      (quotationData.order_summary?.panel_price || 0) -
                      (quotationData.order_summary?.inverter_price || 0)
                    ).toLocaleString("en-IN")}
                  </span>
                </li>

                <li className="d-flex justify-content-between align-items-center border-bottom pb-1">
                  <span className="text-muted">Total System Cost</span>
                  <span className="fw-bold text-dark">
                    ₹{quotationData.payment.total_cost?.toLocaleString("en-IN") || "0"}
                  </span>
                </li>
                <li className="d-flex justify-content-between align-items-center border-bottom pb-1">
                  <span className="text-muted">Subsidy</span>
                  <span className="fw-bold text-success">
                    ₹{quotationData.payment.subsidy?.toLocaleString("en-IN") || "0"}
                  </span>
                </li>
                {quotationData.payment.discount > 0 && (
                  <li className="d-flex justify-content-between align-items-center border-bottom pb-1">
                    <span className="text-muted">Discount</span>
                    <span className="fw-bold text-success">
                      ₹{quotationData.payment.discount?.toLocaleString("en-IN") || "0"}
                    </span>
                  </li>
                )}
                <li className="d-flex justify-content-between align-items-center border-bottom pb-1">
                  <span className="text-muted">Payable Amount</span>
                  <span className="fw-bold text-primary">
                    ₹{quotationData.payment.payable_amount?.toLocaleString("en-IN") || "0"}
                  </span>
                </li>

                {/* Loan Mode Extras */}
                {quotationData.payment.mode === "loan" && (
                  <>
                    <li className="d-flex justify-content-between align-items-center border-bottom pb-1">
                      <span className="text-muted">Advance Paid</span>
                      <span className="fw-bold text-dark">
                        ₹{quotationData.payment.advance_paid?.toLocaleString("en-IN") || "0"}
                      </span>
                    </li>
                    <li className="d-flex justify-content-between align-items-center pb-1 border-bottom">
                      <span className="text-muted">Remaining on Completion</span>
                      <span className="fw-bold text-danger">
                        ₹{quotationData.payment.pay_later_amount?.toLocaleString("en-IN") || "0"}
                      </span>
                    </li>
                  </>
                )}

                {/* Transaction Details Section */}
                <div className="mt-3">
                  <h6 className="fw-semibold mb-2">Transaction Details</h6>

                  {/* Case 1: Payment not done by customer (manual entry) */}
                  {!quotationData.payment.isPaymentDoneByCustomer ? (
                    <ul className="quotation-payment list-unstyled">
                      <li className="d-flex justify-content-between align-items-center border-bottom pb-1">
                        <span className="text-muted">Received By</span>
                        <span className="fw-bold text-dark">{quotationData.payment.received_by || "-"}</span>
                      </li>
                      <li className="d-flex justify-content-between align-items-center border-bottom pb-1">
                        <span className="text-muted">Received Date</span>
                        <span className="fw-bold text-dark">
                          {quotationData.payment.received_date
                            ? new Date(quotationData.payment.received_date).toLocaleString("en-IN")
                            : "-"}
                        </span>
                      </li>
                      <li className="d-flex justify-content-between align-items-center border-bottom pb-1">
                        <span className="text-muted">Payment Method</span>
                        <span className="fw-bold text-dark">{quotationData.payment.payment_method || "-"}</span>
                      </li>
                      <li className="d-flex justify-content-between align-items-center border-bottom pb-1">
                        <span className="text-muted">Reference Number</span>
                        <span className="fw-bold text-dark">{quotationData.payment.reference_number || "-"}</span>
                      </li>
                      {quotationData.payment.mode === "cash" && (
                        <li className="d-flex justify-content-between align-items-center border-bottom pb-1">
                          <span className="text-muted">Account Number</span>
                          <span className="fw-bold text-dark">{quotationData.payment.account_number || "-"}</span>
                        </li>
                      )}
                    </ul>
                  ) : (
                    // Case 2: Online payment (Razorpay)
                    transactionDetails && (
                      <ul className="quotation-payment list-unstyled">
                        <li className="d-flex justify-content-between align-items-center border-bottom pb-1">
                          <span className="text-muted">Payment ID</span>
                          <span className="fw-bold text-dark">{transactionDetails.paymentId || "-"}</span>
                        </li>
                        <li className="d-flex justify-content-between align-items-center border-bottom pb-1">
                          <span className="text-muted">Order ID</span>
                          <span className="fw-bold text-dark">{transactionDetails.orderId || "-"}</span>
                        </li>
                        <li className="d-flex justify-content-between align-items-center border-bottom pb-1">
                          <span className="text-muted">Date</span>
                          <span className="fw-bold text-dark">
                            {transactionDetails.createdAt
                              ? new Date(transactionDetails.createdAt).toLocaleDateString("en-IN")
                              : "-"}
                          </span>
                        </li>
                        <li className="d-flex justify-content-between align-items-center border-bottom pb-1">
                          <span className="text-muted">Status</span>
                          <span className="fw-bold text-primary">{transactionDetails.status || "-"}</span>
                        </li>
                        <li className="d-flex justify-content-between align-items-center border-bottom pb-1">
                          <span className="text-muted">Email</span>
                          <span className="fw-bold text-dark">{transactionDetails.email || "-"}</span>
                        </li>
                        <li className="d-flex justify-content-between align-items-center border-bottom pb-1">
                          <span className="text-muted">Contact</span>
                          <span className="fw-bold text-dark">{transactionDetails.contact || "-"}</span>
                        </li>
                        <li className="d-flex justify-content-between align-items-center border-bottom pb-1">
                          <span className="text-muted">Amount Paid</span>
                          <span className="fw-bold text-success">
                            ₹{(transactionDetails.amount / 100)?.toLocaleString("en-IN") || "0"}
                          </span>
                        </li>
                      </ul>
                    )
                  )}
                </div>
              </ul>
            ) : (
              <p>Loading payment details...</p>
            )}
          </div>
        </div>

        {/* Documents */}
        <div className="col-lg-6">
          <div className="customer-detail-box p-20 shadow-sm h-100">
            <h5 className="mb-3 d-flex align-items-center gap-2">
              <FaFileAlt className="text-info fs-4" /> |  Documents
            </h5>
            {documentData ? (
              <table className="table border-primary-table mb-0 text-center">
                <thead>
                  <tr>
                    <th className="text-center">Document</th>
                    <th className="text-center">Status</th>
                    <th className="text-center">Action</th>
                    <th className="text-center">Download</th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    { name: "Aadhar Card", data: documentData.aadhar_card },
                    { name: "PAN Card", data: documentData.pan_card },
                    { name: "Electricity Bill", data: documentData.electricity_bill },
                    { name: "Bank Passbook", data: documentData.bank_passbook },
                  ].map((doc, idx) => (
                    <tr key={idx}>
                      <td>{doc.name}</td>
                      <td>
                        <span className={
                          doc.data.status === "Verified"
                            ? "text-success"
                            : doc.data.status === "Under Review"
                              ? "text-warning"
                              : "text-danger"
                        }>
                          {doc.data.status || "-"}
                        </span>
                      </td>
                      <td>
                        {doc.data.status === "Under Review" ? (
                          <div className="d-flex gap-2">
                            <button
                              className="btn btn-success"
                              onClick={() => updateDocumentStatus(doc.name.toLowerCase().replace(/\s/g, "_"), "Verified")}
                            >
                              Approve
                            </button>
                            <button
                              className="btn btn-danger"
                              onClick={() => updateDocumentStatus(doc.name.toLowerCase().replace(/\s/g, "_"), "Rejected")}
                            >
                              Reject
                            </button>
                          </div>
                        ) : "-"}
                      </td>
                      <td>
                        <div className="d-flex align-items-center justify-content-center">


                          {/* View Icon */}
                          <Link
                            onClick={() => {
                              const basePath = process.env.REACT_APP_UPLOAD_PATH;
                              const filePath = doc?.data?.url || doc?.url;
                              const fileUrl = `${basePath}${filePath}`;
                              window.open(fileUrl, "_blank");
                            }}
                            className="w-32-px h-32-px me-12 bg-primary-light text-primary-600 rounded-circle d-inline-flex align-items-center justify-content-center"
                            title="View"
                          >
                            <Icon icon="iconamoon:eye-light" color="#000" />
                          </Link>

                          {/* Download Icon */}
                          <Link
                            onClick={() => {
                              const basePath = process.env.REACT_APP_UPLOAD_PATH;
                              const filePath = doc?.data?.url || doc?.url;
                              const fileUrl = `${basePath}${filePath}`;

                              fetch(fileUrl)
                                .then((response) => {
                                  if (!response.ok) throw new Error("Network response was not ok.");
                                  return response.blob();
                                })
                                .then((blob) => {
                                  const url = window.URL.createObjectURL(blob);
                                  const a = document.createElement("a");
                                  a.href = url;
                                  a.download = filePath.split("/").pop();
                                  document.body.appendChild(a);
                                  a.click();
                                  a.remove();
                                  window.URL.revokeObjectURL(url);
                                })
                                .catch((error) => {
                                  console.error("Download error:", error);
                                  alert("File could not be downloaded.");
                                });
                            }}
                            className="w-32-px h-32-px bg-primary-light text-primary-600 rounded-circle d-inline-flex align-items-center justify-content-center"
                            title="Download"
                          >
                            <Icon icon="mdi:download" color="#000" />
                          </Link>
                        </div>
                      </td>


                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <p>Loading documents...</p>
            )}
          </div>
        </div>

        {/* Quotation Breakdown */}
        <div className="col-lg-6">
          <div className="customer-detail-box p-20 shadow-sm h-100">
            <h5 className="mb-3 d-flex align-items-center gap-2">
              <FaFileInvoice className="text-warning fs-4" /> | Quotation Breakdown
            </h5>
            {quotationData?.quotation_breakdown?.length > 0 ? (
              <div>
                {quotationData.quotation_breakdown.map((item, idx) => (
                  <p key={idx}><strong>{item.title}:</strong> ₹{item.amount.toLocaleString("en-IN")}</p>
                ))}
              </div>
            ) : (
              <p>Loading quotation details...</p>
            )}
          </div>
        </div>

      </div>
    </div>
  );
};

export default Customerorderdetails;
